"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireWildcard(require("../../../atoms/Image/Image"));

var _proptypes = require("../../../services/proptypes");

var ImageRow = function ImageRow(_ref) {
  var imageGroup = _ref.imageGroup;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: imageGroup.length,
    style: {
      padding: '0'
    }
  }, imageGroup.map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      key: (0, _Image.getImageKey)(image),
      style: {
        padding: '0.3em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      background: true,
      imageQuery: image,
      src: image,
      style: {
        paddingTop: '100%'
      }
    }));
  }));
};

var _default = ImageRow;
exports["default"] = _default;
ImageRow.propTypes = {
  imageGroup: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_proptypes.GatsbyImagePropType)]).isRequired
};